<template>
  <div class="lessons__status-wrap" v-if="lessonStatus">
    <div class="lessons__status-select" @click="viewStatus = !viewStatus">
      <button
        class="lessons__selected-status"
        :class="[
          {
            'lesson__status-green': lessonStatus.color === 'green'
          },
          {
            'lesson__status-grey': lessonStatus.color === 'grey'
          },
          {
            'lesson__status-yellow': lessonStatus.color === 'yellow'
          },
          {
            'lesson__status-red-with-pay': lessonStatus.color === 'red-pay'
          },
          {
            'lesson__status-blue': lessonStatus.color === 'blue'
          }
        ]"
      >
        <div v-if="lessonStatus.icon" class="pay-icon">
          <icon :name="lessonStatus.icon" />
        </div>
        <div
          class="lessons__selected-status_text"
          :class="[
            {
              'text-blue': lessonStatus.color === 'blue'
            },
            {
              'text-grey': lessonStatus.color === 'grey'
            }
          ]"
        >
          <span>{{ lessonStatus.name }}</span>
        </div>
        <div class="lessons__selected-vektor_icon" v-if="drop">
          <icon name="vektor" />
        </div>
      </button>
    </div>
    <div
      v-if="viewStatus && drop && lessonStatusId_state"
      class="lessons__statuses"
    >
      <div
        class="lessons__status-select"
        v-for="stat in filterStatuses"
        :key="stat.id"
      >
        <button
          @click="selectedStatus(stat)"
          class="lessons__selected-status"
          :class="[
            {
              'lesson__status-green': stat.color === 'green'
            },
            {
              'lesson__status-grey': stat.color === 'grey'
            },
            {
              'lesson__status-yellow': stat.color === 'yellow'
            },
            {
              'lesson__status-red-with-pay': stat.color === 'red-pay'
            },
            {
              'lesson__status-blue': stat.color === 'blue'
            }
          ]"
        >
          <div class="lessons__selected-status_icon">
            <icon :name="stat.icon" />
          </div>
          <div
            class="lessons__selected-status_text"
            :class="[
              {
                'text-blue': stat.color === 'blue'
              },
              {
                'text-grey': stat.color === 'grey'
              }
            ]"
          >
            <span>{{ stat.name }}</span>
          </div>
        </button>
      </div>

      <div
        class="select-status-modal"
        v-if="
          latest_meeting_status &&
          latest_meeting_status.visibility &&
          latest_meeting_status.visibility.received_salary_status_view &&
          lessonStatusId_state !== 6 &&
          lessonStatusId_state !== 1
        "
      >
        <span>יצא לדוח שכר</span>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.375 15V6C4.375 5.44772 4.82272 5 5.375 5L8.875 5C10.5319 5 11.875 6.34315 11.875 8V11.25"
            stroke="#5A6F95"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.125 9.375V15H12.625C14.2819 15 15.625 13.6569 15.625 12V5"
            stroke="#5A6F95"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <NewChekbox
          :checkedProps="isChecked"
          @checked="checkboxChange"
        ></NewChekbox>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NewChekbox from '@/Components/UI/Form/CheckboxNew.vue';
export default {
  name: 'SelectStatusLesson',
  components: { NewChekbox },
  props: {
    latest_meeting_status: {
      type: Object
    },
    is_report: {
      type: Boolean
    },
    statusUpdate: {
      type: Boolean
    },
    statusSee: {
      type: Boolean
    },
    lessonStatusId: {
      type: [Number, String]
    },
    lesson_started: {
      type: Boolean
    },
    changeStatusLesson: {
      type: Object
    },
    drop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      lessonStatusId_state: this.lessonStatusId,
      viewStatus: false,
      isChecked:
        this.latest_meeting_status?.received_salary_status == 1 ? true : false,
      statuses: [
        {
          icon: '',
          name: 'התקיים',
          id: 2,
          color: 'green'
        },
        {
          icon: '',
          name: 'לא התקיים',
          id: 4,
          color: 'red-pay'
        },
        {
          icon: '',
          name: 'מתוכנן',
          id: 1,
          color: 'blue'
        },
        {
          icon: '',
          name: 'מועד עבר',
          id: 6,
          color: 'yellow'
        }
        // {
        //   icon: '',
        //   name: 'מועמד',
        //   id: 7,
        //   color: 'yellow-sweet'
        // }
      ],
      lessonStatus: null
    };
  },

  computed: {
    ...mapState({
      daySlot: s => s.studyCenter.dayPopupDaySlot
    }),
    filterStatuses() {
      if (this.lessonStatusId_state === 1) {
        const statuses = this.statuses.filter(el => el.id == 5);
        return statuses;
      }
      //   if (this.lessonStatusId === 1 && this.lesson_started) {
      //     const statuses = this.statuses.filter(
      //       el => el.id == 3 || el.id == 2 || el.id == 5
      //     );
      //     return statuses;
      //   }
      if (this.lessonStatusId_state === 4) {
        const statuses = this.statuses.filter(
          el => el.id == 5 || el.id == 2 || el.id == 6
        );
        return statuses;
      }
      if (this.lessonStatusId_state === 2) {
        const statuses = this.statuses.filter(
          el => el.id == 3 || el.id == 4 || el.id == 5 || el.id == 6
        );
        return statuses;
      }
      if (this.lessonStatusId_state === 3) {
        const statuses = this.statuses.filter(el => el.id == 4 || el.id == 5);
        return statuses;
      }
      if (this.lessonStatusId == 5) {
        const statuses = this.statuses.filter(
          el => el.id == 2 || el.id == 4 || el.id == 3 || el.id == 6
        );
        return statuses;
      }
      if (this.lessonStatusId_state === 6) {
        const statuses = this.statuses.filter(
          el => el.id == 2 || el.id == 5 || el.id == 3 || el.id == 4
        );
        return statuses;
      }
      //   if (this.lessonStatusId == 5 && this.lesson_started) {
      //     const statuses = this.statuses.filter(
      //       el => el.id == 2 || el.id == 3 || el.id == 4
      //     );
      //     return statuses;
      //   }
      else {
        return this.statuses;
      }
    }
  },
  watch: {
    lessonStatusId(val) {
      this.lessonStatusId_state = val;
      const status = this.statuses.find(el => el.id == val);
      setTimeout(() => {
        this.selectStatus(status);
      }, 0);
      console.log(val, 'lessonStatusId watch');
    },
    lessonStatusId_state(val) {
      if (val == null) {
        this.lessonStatus = null;
      }
      const status = this.statuses.find(el => el.id == val);
      setTimeout(() => {
        this.selectStatus(status);
      }, 0);
    },
    changeStatusLesson(val) {
      if (val !== null) {
        this.selectStatus(val);
      }
    }
  },
  mounted() {
    if (this.is_report) {
      this.statuses = this.statuses.filter(el => el.id !== 3);
    }
  },
  created() {
    const status = this.statuses.find(el => el.id == this.lessonStatusId_state);

    setTimeout(() => {
      this.selectStatus(status);
      console.log(status, this.lessonStatusId, 'status select');
    }, 0);
  },
  methods: {
    checkboxChange(elem, val) {
      this.isChecked = val;
      this.$emit('checkboxStatusChanged', val);
    },
    selectStatus(item) {
      this.lessonStatus = {};
      if (typeof item === 'object' && item !== null) {
        this.lessonStatus = Object.assign({}, item);
      }
      // this.lessonStatus = Object.assign(item);
    },
    selectedStatus(item) {
      this.lessonStatusId_state = item.id;
      this.$emit('lesson_status_state', item.id);
      if (item.id !== 5 && item.id !== 3 && item.id !== 4) {
        this.lessonStatus = {};
        this.lessonStatus = item;
        this.$emit('lessonStatus', item.id);
      }
      if (item.id === 5) {
        this.lessonStatus = item;
        this.$emit('closeLesson', item);
        this.viewStatus = false;
      }
      if (item.id === 3) {
        this.lessonStatus = item;
        this.$emit('replacmentTeacher', item);
        this.viewStatus = false;
      }
      if (item.id === 4) {
        this.lessonStatus = item;
        this.$emit('notComplited', item);
        this.viewStatus = false;
      }
    }
  }
};
</script>

<style lang="scss">
.select-status-modal {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  border-top: 1px solid #e3e7ee;
  padding-top: 8px;

  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: right;
    position: relative;
    left: 4px;
  }
}

.lessons__status-wrap {
  position: relative;
}

.lesson__status-green {
  background: #29cc44;
  // height: 28px !important;
}

.lessons__selected-vektor_icon {
  display: flex;
  align-items: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
  }
}

.lesson__status-red-with-pay {
  background: #ff5040;
}

.lesson__status-red {
  background: #ff3826;
}

.lesson__status-blue {
  background: #e5f2ff;
}

.lesson__status-grey {
  background: #cfd3de;
}

.lesson__status-yellow {
  background: #ffcc33;
}

.pay-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;

  //   width: 16px;
  //   height: 16px;
  svg {
    width: 100%;
    height: 100%;
  }
}

.text-blue {
  color: #409fff !important;
}

.text-grey {
  color: #929baa !important;
}

.lessons__statuses {
  position: absolute;
  top: calc(100% + 8px);
  z-index: 1;
  width: 189px;
  left: 0px;
  border: 0.75px solid #ebeef5;
  box-shadow: 0px 8px 20px rgba(56, 69, 93, 0.1),
    0px 4px 9px rgba(56, 69, 93, 0.08), 0px 2px 5px rgba(56, 69, 93, 0.0596107),
    0px 1px 3px rgba(56, 69, 93, 0.05),
    0px 0.598509px 1.5px rgba(56, 69, 93, 0.0403893),
    0px 0.249053px 1px rgba(56, 69, 93, 0.03);
  background: #ffffff;
  padding: 8px;
  border-radius: 4px;

  .lessons__selected-status_text {
    flex-grow: 0;
  }

  .lessons__selected-status {
    &.lesson__status-yellow {
      .lessons__selected-status_icon {
        display: none;
      }
    }

    &.lesson__status-grey {
      .lessons__selected-status_icon {
        display: none;
      }
    }
  }

  .lessons__status-select {
    justify-content: unset;
  }

  .lessons__status-select:not(:last-child) {
    margin-bottom: 8px;
  }
}

.lessons__selected-status_text {
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  letter-spacing: 0.01em;
  flex-grow: 1;
}

.lessons__selected-status_icon {
  //   width: 16px;
  //   height: 16px;
  display: flex;

  svg {
    width: 100%;
    height: 100%;
  }
}

.lessons__selected-status {
  height: 28px;
  border: none;
  position: relative;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  width: 100%;
}

.test_status {
  background: green;
}

@media (max-width: 490px) {
  .lessons__statuses {
    left: auto;
  }
}
</style>
